export const getPropertyValueByString = (object, property) => {
    property = property.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    property = property.replace(/^\./, '');           // strip a leading dot
    var a = property.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in object) {
            object = object[k];
            if(object === null) {
                return;
            }
        } else {
            return;
        }
    }
    return object;
}

export const createTeamsDeepLink = (appId, entityId, entityWebUrl, isWebUrlRelative) => {
    const url = new URL(entityWebUrl, window.location.href);
    var context = '';

    if (isWebUrlRelative) 
        entityWebUrl = url.href;
    if (url.hash)
        context = `&context=${encodeURIComponent(`{"subEntityId": "${url.hash.substr(1)}"}`)}`;

    return `https://teams.microsoft.com/l/entity/${appId}/${entityId}?webUrl=${encodeURIComponent(entityWebUrl)}${context}`;
}


// WEBPACK FOOTER //
// ./src/helpers/HelperMethods.js